<template>
  <div class="form-group">
    <label>{{ _lang(label,'input') }}</label>

    <template  v-if="existingComponents.includes(type)">
        <component :is="type" :value="value" :label="label" :config="config" @change="input" />
    </template>
    <template  v-else-if="existingComponents.includes('x-'+type)">
        <component :is="'x-'+type" :value="value" :label="label" :config="config" @change="input" />
    </template>

    <template v-else-if="['dbtable'].includes(type)">
        <div class="form-group">
            <select class="form-control" @change="changeXvar('dbtable',$event.target.value)" :value="config.dbtable">
                <option value=""></option>
                <option v-for="table in tables" :value="table.slug">{{table.name}}</option>
            </select>
        </div>
				<div class="form-group">
					<label>{{ _lang('Filter') }}</label>
           <div class="d-flex mb-2" style="align-items:center">
						<select class="form-control" @change="changeXvar('dbfilterfield',$event.target.value)" :value="config.dbfilterfield">
							<option></option>
							<option value="created_at">{{ _lang('Date') }}</option>
							<option value="name">{{ _lang('Name') }}</option>
							<option v-for="field in table.fields" :value="field.slug">{{field.name}}</option>
						</select>

						<input type="text" class="form-control" @change="changeXvar('dbfiltervalue',$event.target.value)" :value="config.dbfiltervalue">

					</div>
        </div>
				<div class="form-group">
					<label>{{ _lang('More Filters') }}</label>
					<input type="text" class="form-control" placeholder="field=value&field2=value2" @change="changeXvar('dbfilterquery',$event.target.value)" :value="config.dbfilterquery">
        </div>

				<div class="form-group">

					<label>{{ _lang('Order') }}</label>
					<div class="d-flex mb-2" style="align-items:center">
						<select class="form-control" @change="changeXvar('dborderfield',$event.target.value)" :value="config.dborderfield">
							<option></option>
							<option value="created_at">{{ _lang('Date') }}</option>
							<option value="name">{{ _lang('Name') }}</option>
							<option v-for="field in table.fields" :value="field.slug">{{field.name}}</option>
						</select>

						<select class="form-control col-5 ml-2"  @change="changeXvar('dborderdir',$event.target.value)" :value="config.dborderdir">
							<option value="asc">{{ _lang('Ascending') }}</option>
							<option value="desc">{{ _lang('Descending') }}</option>
						</select>

					</div>
				</div>


				<div class="form-group">
					<label>{{ _lang('Limit') }}</label>
					<input type="number" class="form-control" @change="changeXvar('dblimit',$event.target.value)" :value="config.dblimit">
        </div>

				<div class="form-group">
					<label>{{ _lang('Offset') }}</label>
					<input type="number" class="form-control" @change="changeXvar('dboffset',$event.target.value)" :value="config.dboffset">
        </div>

    </template>
    <template v-else-if="['table','repeat','repeat-table'].includes(type)">
        <div class="form-group" v-if="type=='table'">

            <div v-if="!formColumnActive">
                <div v-for="(col,index) in columns" class="d-flex align-items-center">
                    <span class="flex-grow-1">{{col.label}}</span>
                    <button :disabled="index==0" class="btn btn-sm btn-light" @click="moveUpCol(col)">▲</button>
                    <button :disabled="index==columns.length-1" class="btn btn-sm btn-light" @click="moveDownCol(col)">▼</button>
                    <button class="btn btn-sm btn-light" @click="formEditColumn(col)">Edit</button>
                    <button class="btn btn-sm btn-light text-danger" @click="deleteColumn(col)">&times;</button>
                </div>
            </div>

            <form v-if="formColumnActive" @submit.prevent="onSubmitColumn">
                <div class="d-flex">
                <div class="form-group w-25">
                    <label>ID</label>
                    <input type="text" v-model="column.key" class="form-control" required pattern="[a-z0-9_]+" title="only letters and numbers">
                </div>
                <div class="form-group w-75">
                    <label>{{ _lang('Title') }}</label>
                    <input type="text" v-model="column.label" class="form-control"  required>
                </div>
                </div>

                <button class="btn btn-sm btn-primary" type="submit">Save</button>
                <button class="btn btn-sm btn-light" @click.prevent="formColumnActive = false">Cancel</button>
            </form>

            <button class="btn btn-sm btn-primary" v-if="!formColumnActive" @click="formAddColumn">Add Column</button>
        </div>

        <div class="form-group">
            <div class="d-flex align-items-center justify-content-between">
                <span class="w-50">{{ _lang('Data source') }}</span>
                <select v-model="sourceType" @change="sourceTypeChange" class="w-50 form-control">
                    <option value="">{{ _lang('Manual') }}</option>
                    <option value="db">{{ _lang('Collection') }}</option>
                    <option v-if="pageFields.length || sourceType=='post'" value="post">{{ _lang('Page field') }}</option>
                    <option v-if="type!='repeat-table' || sourceType=='api'" value="api">API</option>
                </select>
            </div>

            <div v-if="sourceType=='api'" class="d-flex align-items-center justify-content-between">
                <span class="w-50">{{ _lang('API Url') }}</span>
                <input type="text" placeholder="https://" v-model="sourceName" @change="sourceChange(); getSourceData()" class="w-50 form-control">
            </div>
            <div v-if="sourceType=='db'" class="d-flex align-items-center justify-content-between">
                <span class="w-50">{{ _lang('Collection') }}</span>
                <select v-model="sourceName" @change="sourceMap = {}; sourceChange()" class="w-50 form-control">
                    <option value=""></option>
                    <option v-for="table in tables" :value="table.slug">{{table.name}}</option>
                </select>
            </div>
            <select v-if="sourceType=='post'" v-model="sourceName" @change="sourceChange" class="form-control">
                <option value=""></option>
                <option v-for="field in pageFields" :key="field.slug" :value="field.slug">{{field.name}}</option>
            </select>
        </div>

        <fieldset v-if="!sourceType">
            <div v-for="(item,index) in value" :key="index">
                <div class="d-flex align-items-baseline">
                    <div class="badge">{{index+1}}</div>
                    <div class="flex-grow-1" :class="{'d-flex': type=='repeat-table'}">
                        <div v-for="(varobj,varkey) in vars" :key="varkey" :class="{'flex-grow-1': type=='repeat-table'}">
                            <x-input :config="varobj" :name="`${name}[${index}].${varkey}`" :value="item[varkey]" @change="repeatInputChange" />
                        </div>
                    </div>
                    <button class="close" v-if="index>0" @click="repeatRemove(index)">&times;</button>
                </div>
                <hr v-if="type!='repeat-table'">
            </div>
            <button class="btn btn-primary btn-sm" @click="repeatAdd">{{ _lang('Add') }}</button>
        </fieldset>
        <div v-else-if="sourceType!='post'" class="form-group">

            <label>{{ _lang('Mappings') }}</label>
            <separator />
            <div v-for="(varobj,varkey) in vars" :key="varkey" class="d-flex align-items-center justify-content-between">
                <span class="w-50">{{varkey}}</span>
                <select @change="sourceChange" v-model="sourceMap[varkey]" class="w-50 form-control">
                    <option value=""></option>
                    <option v-for="field in sourceFields" :key="field.slug" :value="field.slug">{{field.name}}</option>
                </select>
            </div>

            <!-- {{sourceData}} -->
        </div>
    </template>

    <!-- <input v-else type="text" class="form-control" v-model="handler" @input="input()"> -->


  </div>
</template>

<script>
import Width from './inputs/Width';
import JustifyContent from './inputs/JustifyContent';
import AlignItems from './inputs/AlignItems';
import Background from './inputs/Background';
import BackgroundSize from './inputs/BackgroundSize';
import FontFamily from './inputs/FontFamily';
import FontWeight from './inputs/FontWeight';
import Image from './inputs/Image';
import ImageBg from './inputs/ImageBg';
import Select from './inputs/Select';
import Radio from './inputs/Radio';
import Checkbox from './inputs/Checkbox';
import Textarea from './inputs/Textarea';
import Number from './inputs/Number';
import Link from './inputs/Link';
import Opacity from './inputs/Opacity';
import Code from './inputs/Code';
import Padding from './inputs/Padding';
import Separator from './inputs/Separator';
import Color from './inputs/Color';
import Text from './inputs/Text';
import ColorPicker from './inputs/ColorPicker';
import BorderWidthColor from './inputs/BorderWidthColor';
import BackgroundImage from './inputs/BackgroundImage';
import TextareaStripTags from './inputs/TextareaStripTags';
import VideoPlaylist from './inputs/VideoPlaylist';
import TitleSEO from './inputs/TitleSEO';

// import Inline from './inputs/Inline';

export default {
  name:'x-input',
  components:{
     'width':Width,
     'justify-content':JustifyContent,
     'align-items':AlignItems,
     'background':Background,
     'background-size':BackgroundSize,
     'font-family':FontFamily,
     'font-weight':FontWeight,
     'x-image':Image,
     'image-bg':ImageBg,
     'x-select':Select,
     'x-radio':Radio,
     'x-checkbox':Checkbox,
     'x-textarea':Textarea,
     'x-number':Number,
     'x-link':Link,
     'opacity':Opacity,
     'x-code':Code,
     'padding':Padding,
     'separator':Separator,
     'color':Color,
     'x-text':Text,
     'color-picker':ColorPicker,
     'border-width-color':BorderWidthColor,
     'background-image':BackgroundImage,
     'textarea-strip-tags':TextareaStripTags,
     'video-playlist':VideoPlaylist,
	 'title-seo':TitleSEO,
  },
  props: ['config', 'name', 'value', 'index','disabled'],
  inject: { pageSourceContext: { default: () => () => ({ fields: [], post: null }) } },
  watch: {
      config: {
        immediate: true,
        handler(){
          const config = this.config || {};
          const match = (config.source || '').match(/^(api|db):(.*)$/);
          this.sourceType = config.postfield!==undefined ? 'post' : match ? match[1] : '';
          this.sourceName = config.postfield!==undefined ? config.postfield : match ? match[2] : '';
          this.sourceMap = {...config.sourceMap};
          if(this.sourceType==='api' && this.sourceName) this.getSourceData();
        },
      },
  },
  data(){
      return {
          handler:null,
          existingComponents:[],
          sourceType:'',
          sourceName:'',
          sourceMap:{},
          sourceData:{},

          columns:[],
          column:{},
          formColumnActive:false,
      }
  },
  computed:{
      pageFields(){
          if(!['repeat','repeat-table'].includes(this.type) || Object.keys(this.vars).length!==1) return [];
          return this.pageSourceContext().fields.filter(field => field.type==='multiselect');
      },
      sourceFields(){
          if(this.sourceType!=='db') return Object.keys(this.sourceData[0] || {}).map(slug => ({slug, name:slug}));
          const table = this.tables.find(table => table.slug===this.sourceName);
          const fields = ['name','id','slug','permalink','created_at'].map(slug => ({slug, name:slug==='name' ? 'Name' : slug}));
          fields.push(...(table && table.fields || []));
          for(const slug of Object.values(this.sourceMap)){
              if(slug && !fields.some(field => field.slug===slug)) fields.push({slug, name:slug});
          }
          return fields;
      },
      label(){
          return this.config && this.config.label ? this.config.label : capitalizeFirstLetter(this.name);
      },
      type(){
          return this.config && this.config.type ? this.config.type : 'text';
      },
      options(){
          if(!this.config || !this.config.options) return {};

          if(Array.isArray(this.config.options)){
              var obj = {}
              for(var i in this.config.options){
                  var value = this.config.options[i];
                  obj[value] =value;
              }

              return obj;
          }
          return this.config.options;
      },
      vars(){
          return this.config && this.config.vars ? this.config.vars : {};
      },
      tables(){
          return this.$store.getters.tables;
			},
			table(){
				if(!this.config.dbtable) return {};
				return this.$store.getters.tables.find(table=>table.slug==this.config.dbtable);
      },

  },
  mounted(){

      this.handler = this.value;
      var arr = [];
      for (let [key, value] of Object.entries(this.$options.components)) {
        arr.push(key);
      }
      this.existingComponents = arr;


    this.parseColumns();


  },
  methods:{
		changeXvar(key,value){
			updateXVars(blockObj,this.name,key,value);
			updateIframe();
			this.config[key] = value;
			var dbtable = this.config.dbtable;
			if(dbtable){
				renderCollection(dbtable);
			}
		},

      parseColumns(){
        if(this.vars){
            var aux = [];
            for(var i in this.vars){
                aux.push({
                    key:i,
                    label:this.vars[i].label,
                    type:this.vars[i].type,
                });
            }
            this.columns = aux;
        }
      },
      moveUpCol(col){
          var index = this.columns.indexOf(col);

          this.columns.splice(index,1);
          this.columns.splice(index-1,0,col);

            var dom = htmlToDom(blockObj.template);
            dom.querySelectorAll('table tbody tr').forEach(tr=> {
                tr.insertBefore(tr.querySelector(`td:nth-child(${index+1})`),tr.querySelector(`td:nth-child(${index})`));
            });
            blockObj.template = dom.outerHTML;
            this.renderTableColumns();
      },
        moveDownCol(col){
          var index = this.columns.indexOf(col);

          this.columns.splice(index,1);
          this.columns.splice(index+1,0,col);
            var dom = htmlToDom(blockObj.template);
            dom.querySelectorAll('table tbody tr').forEach(tr=> {
                tr.insertBefore(tr.querySelector(`td:nth-child(${index+1})`),tr.querySelector(`td:nth-child(${index+3})`));
            });
            blockObj.template = dom.outerHTML;
            this.renderTableColumns();
      },

      formAddColumn(){
          this.column  = { key:'col'+(this.columns.length+1) };
          this.formColumnActive = true;
      },
      formEditColumn(col){
          this.column = {
            key:col.key,
            label:col.label,
            type:col.type,
            reference:col,
          }
          this.formColumnActive = true;
      },
      onSubmitColumn(){
          if(this.column.reference){
              var index = this.columns.indexOf(this.column.reference);

              if(this.column.key!=this.column.reference.key){
                  var exists = this.columns.filter(col=>col.key==this.column.key)
                  if(exists.length) {
                      alert(this._lang('Error')+': '+this._lang('Column ID')+` "${this.column.key}" `+this._lang('already exists'));
                      return false;
                  }

                //update column key
                var dom = htmlToDom(blockObj.template);
                var oldKey = this.column.reference.key;
                var subfield = dom.querySelector('table tbody tr').getAttribute('x-for').match(/^(.+) in /).pop();
                var newKey = this.column.key;
                blockObj.template = blockObj.template.replace(new RegExp(`"${subfield}.${oldKey}"`,'g'),`"${subfield}.${newKey}"`);

              }

              this.columns[index] = this.column;

          } else {
              var exists = this.columns.filter(col=>col.key==this.column.key)
              if(exists.length) {
                  alert(this._lang('Error')+': '+this._lang('Column ID')+` "${this.column.key}" `+this._lang('already exists'));
                  return false;
              }
              this.columns.push(this.column);

              //add columns
              var dom = htmlToDom(blockObj.template);
              dom.querySelectorAll('table tbody tr').forEach(row=> {
                  var subfield = row.getAttribute('x-for').match(/^(.+) in /).pop();
                  var newTd = document.createElement('td');
									newTd.setAttribute('x-text',`${subfield}.${this.column.key}`);
									newTd.innerHTML = '<div class="block-dropzone"></div>';
                  row.appendChild(newTd);
              });
              blockObj.template = dom.outerHTML;

          }
          this.formColumnActive = false
          this.renderTableColumns();

      },
      deleteColumn(col){
          if(!confirm('sure?')) return;
          var index = this.columns.indexOf(col);
          this.columns.splice(index,1);

          var dom = htmlToDom(blockObj.template);

          dom.querySelectorAll('table tbody tr').forEach(row=> {
              row.removeChild(row.querySelector('td:nth-child('+(index+1)+')'))
          });
          blockObj.template = dom.outerHTML;
/*
          var key = col.key;
          var row = dom.querySelector('table tbody tr');
          var subfield = row.getAttribute('x-for').match(/^(.+) in /).pop();
          blockObj.template = blockObj.template.replace(new RegExp(`<td.*?x-[^=]*="${subfield}.${key}".*?</td>`,'g'),'')
*/



          this.renderTableColumns();
      },
      renderTableColumns(){
            var dom = htmlToDom(blockObj.template);
            var xVars = looseJsonParse(dom.getAttribute('x-vars')) || {};

            var vars = {};
            this.columns.forEach(col=>{
                vars[col.key] = {
                    label:col.label,
                    type:col.type||'text',
                };
            });
            xVars[this.name].vars = vars;

            var output = modelToString(xVars);

            dom.setAttribute('x-vars',output);

            var html = '';
            this.columns.forEach(col=>{
                html += '<th>'+col.label+'</th>';
            });
            dom.querySelector('table tr').innerHTML = html;

            blockObj.template = dom.outerHTML;

            parseBlockSource();
            updateIframe();
            updateVueData();
      },

			sourceTypeChange(){
                this.sourceName = '';
                this.sourceMap = {};
                this.sourceChange();
			},
      sourceChange(){
        const keys = Object.keys(this.vars);
        if(this.sourceType==='db' && this.sourceName && keys.length===1 && this.sourceMap[keys[0]]===undefined){
            this.$set(this.sourceMap, keys[0], 'name');
        }

        var dom = htmlToDom(blockObj.template);
        var xVars = looseJsonParse(dom.getAttribute('x-vars')) || {};

        var model = xVars[this.name];

        delete model.source;
        delete model.sourceMap;
        delete model.postfield;
        delete model.dbfield;
        if(this.sourceType==='post') model.postfield = this.sourceName;
        else if(this.sourceType){
            model.source = this.sourceType+':'+this.sourceName;
            model.sourceMap = {...this.sourceMap};
        }

        xVars[this.name] = model;

        var output = modelToString(xVars);

        dom.setAttribute('x-vars',output);

        blockObj.template = dom.outerHTML;

        parseBlockSource();
        updateIframe();
        updateBlockList();
        updateVueData();

      },
      getSourceData(){
        //console.log('xinput getting source data')
        if(!this.sourceType || !this.sourceName) return;
        var project_id = this.$store.state.project.id;
        getSourceData(this.sourceType+':'+this.sourceName,project_id).then(data=>{
            this.sourceData = data
        }).catch(() => { this.sourceData = []; });

      },
    repeatInputChange(field,newval){
        this.$emit('change',field,newval);
    },
    repeatAdd(){
        addLoopItem(this.name);
    },
    repeatRemove(index){
        removeLoopItem(this.name,index);
        this.$nextTick(()=>{
            this.$forceUpdate();
        })
    },


    input(arg1, arg2){
        var field = this.name;
        if(arg2!=undefined) {
            field = arg1;
            var newval = arg2;
        } else {
            var newval = arg1;
        }

        newval = newval==undefined?this.handler:newval;

        this.$emit('change',field,newval);
    },


  }

}
</script>
